<template>
    <div class="notifications notifications__modified">
        <notification :key="notifications[idx].nIdx" v-for="(v, idx) in notifications" v-model="notifications[idx]" @close="onNotificationCloseRequested(idx)"></notification>
    </div>
</template>

<script>
    import Notification from './notification.vue';
    import { EventBus } from '../../../utils';

    export default {
        name: 'notifications',

        components: {
            Notification,
        },

        created() {
            EventBus.$on(EventBus.SHOW_NOTIFICATION, this.createNotification);
        },

        data() {
            return {
                nIdx: 0,
                notifications: [],
            };
        },

        methods: {
            createNotification(data) {
                data['nIdx'] = this.nIdx++;
                this.notifications.push(data);
            },
            onNotificationCloseRequested(idx) {
                this.notifications.splice(idx, 1);
            },
        },
    };
</script>

<style lang="scss">
    @import 'notifications.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/notifications/notifications.vue